<template>
  <HXContentCard title="Agregar Centro de Operacion" :toBack="{ name: 'CentrosDeOperacion' }">
    <form @submit.prevent="saveData">
      <div class="row px-5 mt-4">
        <div class="col-md-6">
          <div>
            <label for=" " class="form-label">Nombre Centro de Operacion</label>
            <input v-model="item.descripcion" required placeholder="Escriba el Nombre del Centro de Operacion..."
              type="text" class="form-control" id=" " />
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label">Area</label>
            <b-form-select required v-model="item.areaId" :options="ListAreas" text-field="descripcion"
              value-field="id">
            </b-form-select>
          </div>
        </div>
      </div>
      <div class="text-right px-5 pb-4 d-flex justify-content-end">
        <vs-button icon animation-type="vertical" type="submit">
          <i class="fas fa-save pr-1"></i>
          Guardar Centro de Operacion
          <template #animate>
            <i class="fas fa-save"></i>
          </template>
        </vs-button>
      </div>
    </form>
  </HXContentCard>
</template>
<script>
export default {
  data() {
    return {
      item: {
        descripcion: "",
        areaId: "",
        empresaId: "",
        estado: 1,
      },
      ListAreas: [],
      selected: null,
      empresaSelected: null,
      usuario: {},
    };
  },
  async mounted() {
    this.usuario = JSON.parse(localStorage.getItem("setPersonaAct"));
    console.log("usuario ", this.usuario);
    this.item.empresaId = this.usuario.empresa.id;
    await this.getAreas();


  },
  methods: {
    async getAreas() {
      try {
        const res = await this.$store.dispatch("hl_get", {
          path: "Area/ListArea/" + this.item.empresaId,
        });

        let areas = res.data ?? res ?? [];

        this.ListAreas = areas.map(a => ({
          ...a,
          id: a.id.toString()
        }));

        console.log("Areas cargadas:", this.ListAreas);

      } catch (error) {
        console.log("Error getAreas:", error);
        this.ListAreas = [];
      }
    },


    async saveData() {
      this.isCreating = true;

      try {

        const payload = {
          descripcion: this.item.descripcion,
          areaId: this.item.areaId,
          estado: 1,
          empresaId: this.item.empresaId
        };

        const res = await this.$store.dispatch("hl_post", {
          path: "CentroOperacion/Create",
          data: payload,
        });

        if (res?.success) {
          this.$vs.notification({
            color: "success",
            title: "Éxito",
            text: "Centro de Operacion creado correctamente",
            position: "top-right",
          });

          this.$router.push({ name: "CentrosDeOperacion" });
        }

      } catch (error) {

        console.log("Error backend:", error.response?.data);

        this.$vs.notification({
          color: "danger",
          title: "Error",
          text: "No se pudo crear el Centro de Costo",
          position: "top-right",
        });

      } finally {
        this.isCreating = false;
      }
    },

  },
};
</script>
